export default {
    apiRoot: 'https://96978a80f4f409688ae4aa0ae96bd75.longevist.com',
    siteRoot: 'https://prehabm-test.longevist.com/',
    client_id: 'HcZbUBiaraToGT1DOE281KnppfmwoACHdYYw7iJo',
    client_secret: "4Rv1Cpm778JToC4WYfUX3bmpqpSHGgDUrncqQkVJHfuXxqzdrqQLIRhVdvJeuvWOtDtl6dicojZX3rh6pvhSh1rDB606QgH4YXclErfjYcpaLj5jHOkRABgdnU3vr6sG",
}


// export default {
//     apiRoot: 'https://97f2bd717ae2460494536ddad4093f6f.prehab-m.com',
//     siteRoot: 'https://professional.prehab-m.com',
//     client_id: 'HcZbUBiaraToGT1DOE281KnppfmwoACHdYYw7iJo',
//     client_secret: "4Rv1Cpm778JToC4WYfUX3bmpqpSHGgDUrncqQkVJHfuXxqzdrqQLIRhVdvJeuvWOtDtl6dicojZX3rh6pvhSh1rDB606QgH4YXclErfjYcpaLj5jHOkRABgdnU3vr6sG",
// }
